import { listingReducer } from "../reducers/utils/listingReducer";
import { getTermsConditionsList } from "../../services/termsConditions";

const { reducer, actions, types } = listingReducer({
  name: `termsConditions`,
  getApi: getTermsConditionsList,
});
const termsConditions = reducer;
export { termsConditions, actions, types };